export default "__VITE_ASSET__CMgTMvJN__"